import React from 'react'
import { Box, Typography } from '@mui/material'
import AdxInput from 'components/custom/AdxInput'
import AdxPhoneNumber from 'components/reusable/AdxPhoneNumber/AdxPhoneNumber'
import AdxDropdown from 'components/custom/AdxDropdown'
import AdxMenuItem from 'components/custom/AdxMenuItem'
import AdxDatePicker from 'components/custom/AdxDatePicker'
import AdxErrorMessage from 'components/custom/AdxErrorMessage'
import { ErrorMessage } from 'formik'
import { _calculateAge } from 'services/helper/DateTime'

const relationShipList = [
  'Mother',
  'Father',
  'Spouse',
  'Partner',
  'Son',
  'Daughter',
  'Sibling',
  'Guardian',
  'Mortal',
  'Others',
]

const EditPersonalTab = ({ formikBag, countriesList }) => {
  // Check birth year of 18 years old
  const legalAge = new Date().getFullYear() - 18
  // Check birth year of 60 years old
  const retiredAge = new Date().getFullYear() - 80

  const { values, handleChange, handleBlur, setFieldValue, touched, errors } = formikBag

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {/* Basic Details */}
      <Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            borderBottom: '1px solid',
            borderColor: 'gray-line.main',
            p: 2,
            alignItems: 'center',
          }}
        >
          <Typography color="light-gray-text.main" fontWeight={500}>
            Basic details
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, p: 2 }}>
          <AdxInput
            label="Employee Name"
            sxLabel={{
              color: 'dark-text.main' /*, fontSize: "30px!important" */,
            }}
            sxInput={{
              color: 'light-gray-text.main',
              backgroundColor: 'white.main',
            }}
            size="standard"
            placeholder="Employee Name"
            name="name"
            value={values.name}
            onChange={handleChange}
            onBlur={handleBlur}
            errorMessage={<ErrorMessage name="name" component={AdxErrorMessage} />}
            isErrorShown={touched.name && errors.name}
          />
          <Box sx={{ display: 'flex', alignItems: 'start', gap: 2 }}>
            {/* Gender */}
            <AdxDropdown
              placeholder="Gender"
              label="Gender"
              sx={{ width: '35%' }}
              sxLabel={{
                color: 'dark-text.main' /*, fontSize: "30px!important" */,
              }}
              sxDropdown={{
                color: 'light-gray-text.main',
                backgroundColor: 'white.main',
              }}
              name="gender"
              value={values.gender}
              onChange={handleChange}
              onBlur={handleBlur}
              errorMessage={<ErrorMessage name="gender" component={AdxErrorMessage} />}
              isErrorShown={touched.gender && errors.gender}
            >
              <AdxMenuItem value={'1'} selectedvalue={values.gender}>
                {'Male'}
              </AdxMenuItem>
              <AdxMenuItem value={'2'} selectedvalue={values.gender}>
                {'Female'}
              </AdxMenuItem>
            </AdxDropdown>
            {/* Disability Status */}
            <AdxDropdown
              placeholder="Disability Status"
              label="Disability Status"
              sx={{ width: '65%' }}
              sxLabel={{
                color: 'dark-text.main' /*, fontSize: "30px!important" */,
              }}
              sxDropdown={{
                color: 'light-gray-text.main',
                backgroundColor: 'white.main',
              }}
              name="disability_status"
              value={values.disability_status}
              onChange={handleChange}
              onBlur={handleBlur}
              errorMessage={<ErrorMessage name="disability_status" component={AdxErrorMessage} />}
              isErrorShown={touched.disability_status && errors.disability_status}
            >
              <AdxMenuItem value={1} selectedvalue={values.disability_status}>
                {'Yes'}
              </AdxMenuItem>
              <AdxMenuItem value={0} selectedvalue={values.disability_status}>
                {'No'}
              </AdxMenuItem>
            </AdxDropdown>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <AdxDatePicker
              label="Date of Birth"
              name="dob"
              onChange={(e) => setFieldValue(`dob`, e)}
              onBlur={handleBlur}
              value={values.dob}
              minDate={new Date(retiredAge, 0, 1)}
              maxDate={new Date(legalAge, new Date().getMonth(), new Date().getDate())}
              errorMessage={<ErrorMessage name="dob" component={AdxErrorMessage} />}
              isErrorShown={touched.dob && errors.dob}
              sx={{ width: '35%' }}
            />
            <Box sx={{ width: '65%', pt: 3 }}>
              <Typography variant="body1" color="light-gray-text.main">
                {_calculateAge(values.dob)}
              </Typography>
            </Box>
          </Box>
          <AdxDropdown
            placeholder="Nationality"
            label="Nationality"
            sx={{ width: '100%' }}
            sxLabel={{
              color: 'dark-text.main' /*, fontSize: "30px!important" */,
            }}
            sxDropdown={{
              color: 'light-gray-text.main',
              backgroundColor: 'white.main',
            }}
            value={values.nationality}
            name="nationality"
            onChange={handleChange}
            errorMessage={<ErrorMessage name="nationality" component={AdxErrorMessage} />}
            isErrorShown={touched.nationality && errors.nationality}
          >
            {countriesList &&
              countriesList.length !== 0 &&
              countriesList
                .filter((cc) => cc.country_code !== 'IL')
                .map((item) => (
                  <AdxMenuItem value={item.name} selectedvalue={values.nationality}>
                    {item.name}
                  </AdxMenuItem>
                ))}
          </AdxDropdown>
          <Box
            display="flex"
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              gap: 2,
              alignItems: 'start',
            }}
          >
            <AdxDropdown
              placeholder="Identification type"
              label="Identification type"
              sx={{ width: { xs: '100%', sm: '35%' } }}
              sxLabel={{
                color: 'dark-text.main' /*, fontSize: "30px!important" */,
              }}
              sxDropdown={{
                color: 'light-gray-text.main',
                backgroundColor: 'white.main',
              }}
              name="id_type"
              value={values.id_type}
              onChange={handleChange}
              onBlur={handleBlur}
              errorMessage={<ErrorMessage name="id_type" component={AdxErrorMessage} />}
              isErrorShown={touched.id_type && errors.id_type}
            >
              {values?.nationality === 'Malaysia' && (
                <AdxMenuItem value={'nric'} selectedvalue={values.id_type}>
                  {'NRIC'}
                </AdxMenuItem>
              )}
              <AdxMenuItem value={'passport'} selectedvalue={values.id_type}>
                {'Passport'}
              </AdxMenuItem>
            </AdxDropdown>
            <AdxInput
              label="Identification no."
              sxLabel={{
                color: 'dark-text.main' /*, fontSize: "30px!important" */,
              }}
              sxInput={{
                color: 'light-gray-text.main',
                backgroundColor: 'white.main',
              }}
              size="standard"
              placeholder={values.id_type === 'nric' ? 'E.g: 880208104178' : 'E.g: A34125172'}
              name="id_number"
              value={values.id_number}
              onChange={handleChange}
              onBlur={handleBlur}
              sx={{ width: { xs: '100%', sm: '65%' } }}
              errorMessage={<ErrorMessage name="id_number" component={AdxErrorMessage} />}
              isErrorShown={touched.id_number && errors.id_number}
            />
          </Box>
        </Box>
      </Box>

      {/* Contact Details */}
      <Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            borderBottom: '1px solid',
            borderColor: 'gray-line.main',
            p: 2,
            alignItems: 'center',
          }}
        >
          <Typography color="light-gray-text.main" fontWeight={500}>
            Contact details
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, p: 2 }}>
          <Box
            display="flex"
            flexDirection={{ xs: 'column', sm: 'row' }}
            width={'100%'}
            sx={{ rowGap: 1 }}
          >
            <Box sx={{ width: { xs: '100%', sm: '40%' }, columnGap: 2 }}>
              <AdxPhoneNumber
                label="Phone Number"
                placeholder="E.g: 123456789"
                dropdownName="phone_country_id"
                inputName="phone_no"
                dropdownValue={values.phone_country_id}
                onDropdownChange={(value) => setFieldValue(`phone_country_id`, value)}
                inputValue={values.phone_no}
                onInputChange={handleChange}
                dropdownErrorMessage={
                  touched.phone_country_id && errors.phone_country_id && errors.phone_country_id
                }
                inputErrorMessage={touched.phone_no && errors.phone_no && errors.phone_no}
                dropdownIsErrorShown={touched.phone_country_id && errors.phone_country_id}
                inputIsErrorShown={touched.phone_no && errors.phone_no}
              />
            </Box>
            <Box sx={{ width: { xs: 1, sm: 4 / 7 }, ml: { xs: 0, sm: 2 } }}>
              <AdxInput
                label="Personal Email"
                sxLabel={{
                  color: 'dark-text.main' /*, fontSize: "30px!important" */,
                }}
                sxInput={{
                  color: 'light-gray-text.main',
                  backgroundColor: 'white.main',
                }}
                size="standard"
                placeholder="Personal Email"
                name="personal_email"
                value={values.personal_email}
                onChange={handleChange}
                onBlur={handleBlur}
                errorMessage={<ErrorMessage name="personal_email" component={AdxErrorMessage} />}
                isErrorShown={touched.personal_email && errors.personal_email}
                sx={{ width: 1 }}
              />
            </Box>
          </Box>
          <AdxInput
            label="Home Address"
            sxLabel={{
              color: 'dark-text.main' /*, fontSize: "30px!important" */,
            }}
            sxInput={{
              color: 'light-gray-text.main',
              backgroundColor: 'white.main',
            }}
            size="standard"
            placeholder="Home Address"
            name="address"
            value={values.address}
            onChange={handleChange}
            onBlur={handleBlur}
            sx={{ width: '100%' }}
            multiline
            minRows={3}
            errorMessage={<ErrorMessage name="address" component={AdxErrorMessage} />}
            isErrorShown={touched.address && errors.address}
          />
          <Box
            sx={{ gap: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}
          >
            <AdxInput
              label="Postal code"
              sxLabel={{
                color: 'dark-text.main' /*, fontSize: "30px!important" */,
              }}
              sxInput={{
                color: 'light-gray-text.main',
                backgroundColor: 'white.main',
              }}
              size="standard"
              placeholder="Postal code"
              name="postcode"
              value={values.postcode}
              onChange={handleChange}
              onBlur={handleBlur}
              errorMessage={<ErrorMessage name="postcode" component={AdxErrorMessage} />}
              isErrorShown={touched.postcode && errors.postcode}
              sx={{ width: '36%' }}
            />
            {/* State */}
            <AdxDropdown
              placeholder="State"
              label="State"
              sx={{ width: '36%' }}
              sxLabel={{
                color: 'dark-text.main' /*, fontSize: "30px!important" */,
              }}
              sxDropdown={{
                color: 'light-gray-text.main',
                backgroundColor: 'white.main',
              }}
              name="state"
              value={values.state}
              onChange={handleChange}
              onBlur={handleBlur}
              errorMessage={<ErrorMessage name="state" component={AdxErrorMessage} />}
              isErrorShown={touched.state && errors.state}
            >
              {countriesList &&
                values.country &&
                countriesList.length !== 0 &&
                countriesList
                  ?.find((node) => node.name === values.country)
                  ?.states.map((item) => (
                    <AdxMenuItem value={item.name} selectedvalue={values.state}>
                      {item.name}
                    </AdxMenuItem>
                  ))}
            </AdxDropdown>
            {/* Country */}
            <AdxDropdown
              placeholder="Country"
              label="Country"
              sx={{ width: '36%' }}
              sxLabel={{
                color: 'dark-text.main' /*, fontSize: "30px!important" */,
              }}
              sxDropdown={{
                color: 'light-gray-text.main',
                backgroundColor: 'white.main',
              }}
              name="country"
              value={values.country}
              onChange={handleChange}
              onBlur={handleBlur}
              errorMessage={<ErrorMessage name="country" component={AdxErrorMessage} />}
              isErrorShown={touched.country && errors.country}
            >
              {countriesList &&
                countriesList.length !== 0 &&
                countriesList
                  .filter((cc) => cc.country_code !== 'IL')
                  .map((item) => (
                    <AdxMenuItem value={item.name} selectedvalue={values.country}>
                      {item.name}
                    </AdxMenuItem>
                  ))}
            </AdxDropdown>
          </Box>
          <AdxInput
            label="Emergency contact name"
            sxLabel={{
              color: 'dark-text.main' /*, fontSize: "30px!important" */,
            }}
            sxInput={{
              color: 'light-gray-text.main',
              backgroundColor: 'white.main',
            }}
            size="standard"
            placeholder="Emergency contact name"
            name="emergency_contact_name"
            value={values.emergency_contact_name}
            onChange={handleChange}
            onBlur={handleBlur}
            errorMessage={
              <ErrorMessage name="emergency_contact_name" component={AdxErrorMessage} />
            }
            isErrorShown={touched.emergency_contact_name && errors.emergency_contact_name}
            sx={{ width: '100%' }}
          />
          <Box
            sx={{
              width: '100%',
              gap: 2,
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              alignItems: 'start',
            }}
          >
            <Box width={{ xs: 1, sm: '40%' }}>
              {/* Relationship */}
              <AdxDropdown
                placeholder="Relationship"
                label="Relationship"
                sxLabel={{
                  color: 'dark-text.main' /*, fontSize: "30px!important" */,
                }}
                sxDropdown={{
                  color: 'light-gray-text.main',
                  backgroundColor: 'white.main',
                }}
                name="emergency_contact_relationship"
                value={values.emergency_contact_relationship}
                onChange={handleChange}
                onBlur={handleBlur}
                errorMessage={
                  <ErrorMessage name="emergency_contact_relationship" component={AdxErrorMessage} />
                }
                isErrorShown={
                  touched.emergency_contact_relationship && errors.emergency_contact_relationship
                }
              >
                {relationShipList.map((rel) => (
                  <AdxMenuItem
                    value={rel}
                    selectedvalue={values.emergency_contact_emergency_contact_relationship}
                  >
                    {rel}
                  </AdxMenuItem>
                ))}
              </AdxDropdown>
            </Box>
            <Box width={{ xs: 1, sm: '60%' }}>
              <AdxPhoneNumber
                label="Phone Number"
                placeholder="E.g: 123456789"
                sxInput={{ width: '100%' }}
                dropdownName="emergency_contact_phone_country_id"
                dropdownValue={values.emergency_contact_phone_country_id}
                onDropdownChange={(value) =>
                  setFieldValue(`emergency_contact_phone_country_id`, value)
                }
                inputName="emergency_contact_phone_no"
                inputValue={values.emergency_contact_phone_no}
                onInputChange={handleChange}
                dropdownErrorMessage={
                  touched.emergency_contact_phone_country_id &&
                  errors.emergency_contact_phone_country_id &&
                  errors.emergency_contact_phone_country_id
                }
                inputErrorMessage={
                  touched.emergency_contact_phone_no &&
                  errors.emergency_contact_phone_no &&
                  errors.emergency_contact_phone_no
                }
                dropdownIsErrorShown={
                  touched.emergency_contact_phone_country_id &&
                  errors.emergency_contact_phone_country_id
                }
                inputIsErrorShown={
                  touched.emergency_contact_phone_no && errors.emergency_contact_phone_no
                }
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default EditPersonalTab
